module.exports = __webpack_public_path__ + "img/sofia.a186be8d.jpg";